module.exports = __webpack_public_path__ + "img/icon-articulating-screens.7f5e3a9b.svg";